import gql from 'graphql-tag';

export const GET_FINANCE_SUMMARY = gql`
  query GetTransactionSummary {
    getTransactionSummary {
      name
      totalAmount
      totalAmountPending
      totalTransactions
    }
  }
`;

export const GET_FINANCE = gql`
  query GetTransactions($queries: PaymentsQuery!) {
    getTransactions(queries: $queries) {
      total
      data {
        _id
        createdAt
        user {
          lastName
          firstName
          phoneNumber
        }
        status
        price
        payment_method
        refCommand
        subscription_packages_ref {
          description
        }
      }
    }
  }
`;
